import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'foneMask',
})
export class FoneMaskPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (!value) {
      return '';
    }

    const tel = value.toString().replace(/\D/g, '');

    if (tel.length === 10) {
      return tel.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3'); // (00) 0000-0000
    } else if (tel.length === 11) {
      return tel.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3'); // (00) 00000-0000
    }

    return value.toString();
  }
}
